import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  Pagination,
  Grid,
  InputBase
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ControlPointOutlinedIcon from '@mui/icons-material/ControlPointOutlined';
import SearchIcon from "@mui/icons-material/Search";
// import UserProfileService from '../../services/Profile.services';
import UserProfileService from '../../../services/Profile.services';
import OnboardEmployeeDialog from '../../../pages2/Help/createClientPop';
import OnboardClientDialog from '../../../pages2/Help/createEmployeePop';
// import { CustomSecondaryButton, CustomSecondaryDownLoadButton, CustomSecondaryEditButton, CustomSuccessButton } from '../../../Global_Component/GlobalButtonComponent';

// import EmployeeWorkingDetail from "../../Hala_india_Dashboard/Master_Admin_Portal/EmployeeWorkingDetail"

import ResultTable from "./employee/ResultTable"
import ResultClient from "./client/ResultTable"
const data = [
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  {
    id: 1,
    companyName: 'Savorybites',
    appDate: '12/01/24',
    industry: 'Fitness',
    mobileNumber: '+966563912928',
    status: 'Active',
    contactPerson: 'Aslam zaki',
    logo: 'https://via.placeholder.com/40',
  },
  // Add other rows as per the image
];

export default function ClientProfile() {
    const [activeTab, setActiveTab] = useState(0);
  
    const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
    };


    const[comapny,setCompany]=useState([])
const [dailogueOpen,setDailogueOpen]=useState(false)
const [openClient,setOpenClient]=useState(false)

async function fetchCompany(params) {
 const response=await UserProfileService.getAllUser()
 console.log("response",response.data)
 setCompany(response?.data)
}



  
    return (
      <Box  sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          maxHeight: "100%",
          padding:2,
         
          overflowY: "auto",
          textAlign:"left",
          bgcolor:"#EDF2F9",
          // Custom scrollbar styles
          "&::-webkit-scrollbar": {
            width: "6px", // Width of the scrollbar
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f1f1f1", // Track color
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888", // Thumb color
            borderRadius: "10px", // Optional rounded edges for the thumb
          },
          "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "#555", // Thumb color on hover
          },
        }}>


<OnboardEmployeeDialog open={dailogueOpen} handleClose={()=>setDailogueOpen(false)}/>
<OnboardClientDialog open={openClient} handleClose={()=>setOpenClient(false)}/>

<Grid container sm={11} sx={{display:"flex",alignItems:"flex-end",justifyContent:"flex-end",mb:2,mt:0.2}} spacing={2}>
<Button onClick={e=>setOpenClient(true)} variant='contained'sx={{mx:2,bgcolor:"white",color:"black",textTransform:"none",":hover":{bgcolor:"white"}}} startIcon={<ControlPointOutlinedIcon/>}> onBoard new Client </Button>
<Button onClick={()=>setDailogueOpen(true)} variant='contained'sx={{mx:2,bgcolor:"white",color:"black",textTransform:"none",":hover":{bgcolor:"white"}}} startIcon={<ControlPointOutlinedIcon/>}> onBoard new employee </Button>
</Grid>


        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
  
          sx={{
            borderBottom: 2,
            paddingBottom:1,
            
            bgcolor:"white",
            width:"100%",
            borderColor: "divider",
            "& .MuiTab-root": { textTransform: "none", fontWeight: "500" },
          }}
        >
          <Tab label="Employee" />
          <Tab label="Client" />
        </Tabs>
  
        {/* Content Area */}
        <Box  sx={{width:"100%"}}>
          {activeTab === 0 && <ResultTable />}
          {activeTab === 1 && <ResultClient />}
        </Box>
      </Box>
    );
  }
  